'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIRouterNavButton from 'ui-addon-react-router-dom/UIRouterNavButton';

const NotFoundError = () => {
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    type: "notFound",
    title: unescapedText('marketplace-assets-ui.error.notFound.title'),
    children: /*#__PURE__*/_jsx(UIRouterNavButton, {
      className: "m-top-4",
      exact: true,
      to: "/",
      use: "tertiary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.error.notFound.button"
      })
    })
  });
};

export default NotFoundError;